import React from 'react';
import { FormWithPrivacyHandler } from 'components/molecules/custom-form';
import {
  useProjectAsRBACResource,
  useWithAccess,
} from 'hooks/rbac/useWithAccess';
import {
  useDiscussionsDispatch,
  editCommmentOnStore,
} from '../discussions-store';

export const EditComment = ({
  initialHtml,
  placeholder,
  projectId,
  docId,
  comment,
  onEditFormClose,
}) => {
  const dispatch = useDiscussionsDispatch();
  const handleEdit = (content) => {
    if (content.length > 1) {
      editCommmentOnStore(dispatch, {
        projectId,
        docId,
        comment,
        content,
      });
      onEditFormClose();
    }
  };

  const { hasAccessToResource } = useWithAccess();
  const projectResource = useProjectAsRBACResource(projectId);

  const canCreatePrivateConversation = hasAccessToResource({
    actionScope: ['PRIVATE'],
    rule: 'CONVERSATION:CREATE',
    resourceData: projectResource,
  });

  const canCreateSharedConversation = hasAccessToResource({
    actionScope: ['SHARED'],
    rule: 'CONVERSATION:CREATE',
    resourceData: projectResource,
  });

  const canToggleConversationPrivacy =
    canCreatePrivateConversation && canCreateSharedConversation;

  return (
    <FormWithPrivacyHandler
      initialFormVisibility
      submitFormLabel="save"
      onSubmit={handleEdit}
      isPrivate={comment.private}
      onClose={onEditFormClose}
      initialData={initialHtml}
      placeholder={placeholder}
      hidePrivateToggler
      projectId={projectId}
      conversationPrivacy={{
        private: canCreatePrivateConversation && !canToggleConversationPrivacy,
        shared: canCreateSharedConversation && !canToggleConversationPrivacy,
        toggle: canToggleConversationPrivacy,
      }}
    />
  );
};
